export class ListKnownAppsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apps",
            "baseName": "apps",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListKnownAppsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
